/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.FavouriteDocuments";
        /**
         * Component for display of recent documents for the user.
         */
        class ComponentFavouriteDocuments extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = false;
                this._dataList = null;
                // External interaction
                this.DocumentSelectedCallBack = null;
                // UI Elements
                this._loader = null;
                this._noRecords = null;
                this._listContainer = null;
                this._removeStyles = ['wpt-font-icon_Trash'];
                // State
                this._favouriteItems = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentFavouriteDocuments._storeHtml()");
                    ComponentFavouriteDocuments.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._requestHitlist = () => {
                    this._log.info("ComponentFavouriteDocuments._requestHitlist()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/GetFavourites', this._displayResult, this._errorCallback, this._failCallback);
                };
                this._displayResult = (response) => {
                    this._log.info("ComponentFavouriteDocuments._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    this._dataList.clearList();
                    let itemsLength = 0;
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        this._favouriteItems = response.Documents;
                        itemsLength = response.Documents.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got documents: " + itemsLength);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < itemsLength; i++) {
                            let item = response.Documents[i];
                            let itemData = {
                                Id: item.ItemNum.toString(10),
                                DisplayName: item.Name
                            };
                            let icon = {
                                Classes: [...this._removeStyles],
                                Title: this._core.Locale.getTranslation('STR_WPT_REMOVE_FROM_FAVOURITE'),
                                Callback: this._removeDocument
                            };
                            itemData.SuffixIcons = [icon];
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got NO documents");
                        }
                        this._core.Functions.showElement(this._noRecords);
                        this._favouriteItems = [];
                    }
                };
                this._docSelected = (itemNum) => {
                    this._log.info("ComponentFavouriteDocuments._docSelected()");
                    let docId = Number(itemNum);
                    let doc = this._favouriteItems.find(r => r.ItemNum == docId);
                    if (!doc) {
                        console.warn("Favourite Documents Component: Unrecognised document handle selected.");
                        return;
                    }
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(itemNum);
                    if (this.DocumentSelectedCallBack)
                        this.DocumentSelectedCallBack(doc);
                };
                this._removeDocument = (itemNum, event) => {
                    this._log.info("ComponentFavouriteDocuments._removeDocument()");
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent display of document
                    }
                    this._core.Loader.genericServiceCall(`/User.svc/rest/DeleteFavourite/${itemNum}`, this._docRemoved, this._errorCallback, this._failCallback);
                };
                this._docRemoved = (response) => {
                    this._log.info("ComponentFavouriteDocuments._docRemoved()");
                    this.refresh();
                };
                this.refresh = () => {
                    this._log.info("ComponentFavouriteDocuments.refresh()");
                    if (this._componentReady)
                        this._requestHitlist();
                    else
                        this._displayPending = true;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentFavouriteDocuments::constructor");
                this._config = config;
                // But the html is static
                if (!ComponentFavouriteDocuments.Html) {
                    core.Loader.getVersionedHTML('widgets/components/favouritedocuments.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentFavouriteDocuments._present()");
                if (!this._readyToPresent) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("not ready - pausing");
                    }
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentFavouriteDocuments.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#favouriteDocsNoRecords');
                this._listContainer = this._container.querySelector('#favouriteDocsListContainer');
                this._core.Helper.prepareHourglassIcon(this._loader);
                // Translations
                this._core.Helper.setElementTranslation(this._container.querySelector('#favouriteDocsLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#favouriteDocsNoRecordsLabel'), 'STR_WPT_NOINFO');
                // Options
                if (this._config.hasOwnProperty('RemoveButtonIconStyles') && (this._config.RemoveButtonIconStyles != null))
                    this._removeStyles = this._config.RemoveButtonIconStyles;
                let listConfig = {
                    SelectItemCallback: this._docSelected
                };
                this._dataList = new Widgets.ComponentDataList(this._core, this._listContainer, null, listConfig);
                this._dataList.present();
                // Go!
                this._componentReady = true;
                if (this._displayPending)
                    this._requestHitlist();
            }
        }
        ComponentFavouriteDocuments.Html = null;
        Widgets.ComponentFavouriteDocuments = ComponentFavouriteDocuments;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
